import React from "react";
import styled, { css } from "styled-components";
import ModeToggler from "../Icons/ModeToggeler.js";

import { BrowserRouter as Router, Route, NavLink } from "react-router-dom";

import InfoIcon from "../Icons/Info";
import Info from "./Info";
import Countries from "./Countries";
import Globe from "../Icons/Globe.js";
import Lang from "../Icons/Lang.js";
import People from "../Icons/People.js";
import Languages from "./Languages.js";
import Contributors from "./Contributors.js";

const SideMenu = ({ isMenuOpen, mode, handleMode, handleOpenMenu, currentlyOpenedPage }) => {
    return <Router>
        <Container isMenuOpen={ isMenuOpen }>
            { isMenuOpen
                ? <PageWrapper mode={ mode }>
                    <Route 
                        component={ ({ history }) => <Countries currentlyOpenedPage={ currentlyOpenedPage } history={ history } /> } 
                        path="/countries" />
                    <Route 
                        component={ ({ history }) => <Info currentlyOpenedPage={ currentlyOpenedPage } history={ history } /> } 
                        path="/info" />
                    <Route 
                        component={ Languages }
                        path="/langs" />
                    <Route 
                        component={ Contributors }
                        path="/topContributors" />
                </PageWrapper>
                : null }
            <Navigation mode={ mode }>
                <div>
                    <Button onClick={ handleMode } mode={ mode }>
                        <ModeToggler mode={ mode } />
                    </Button>
                    <NavLink 
                        className="button" 
                        to="/countries" 
                        onClick={ () => handleOpenMenu('countries') } 
                        mode={ mode }>
                        <Globe mode={ mode } />
                    </NavLink>
                    <NavLink 
                        className="button" 
                        to="/langs" 
                        mode={ mode } 
                        onClick={ () => handleOpenMenu('langs') } >
                        <Lang mode={ mode } />
                    </NavLink>
                    <NavLink
                        className="button" 
                        to="/topContributors"
                        onClick={ () => handleOpenMenu('top') } 
                        mode={ mode }>
                        <People mode={ mode } />
                    </NavLink>
                </div>
                <NavLink 
                    className="button" 
                    to="/info" 
                    mode={ mode } 
                    onClick={ () => handleOpenMenu('info') } >
                    <InfoIcon mode={ mode } />
                </NavLink>
            </Navigation>
        </Container>
    </Router>
}

const Container = styled.div`
    min-height: 100vh;
    display: flex;
`

const Navigation = styled.div`
    height: 100%;
    padding: 18px 0;
    flex-direction: column;
    background: #e2e2e2;
    ${ props => props.mode === "dark" && css`background: #2d2d2d;` }
    width: 64px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .button {
        width: 50px;
        height: 50px;
        cursor: pointer;
        border: none;
        background: #efefef;
        border-radius: 5px;
        margin-bottom: 12px;
        display: flex;
        align-items: center;
        justify-content: center;

        ${ props => props.mode === "dark" && css`background: #171717;` }
    }
`

const PageWrapper = styled.div`
    width: calc(350px - 64px);
    background: #f3f0f0;
    overflow: auto;
    height: 100vh;

    &::-webkit-scrollbar-thumb {
        background: #565656;
        border-radius: 10px;
    }

    &::-webkit-scrollbar {
        background: #40404075;
        width: 8px;
        border-radius: 10px;
    }

    ${ props => props.mode === "dark" && css`background: #1d1d1d;`}
`

const Button = styled.button`
    width: 50px;
    height: 50px;
    cursor: pointer;
    border: none;
    /* background: #efefef; */
    background: transparent;
    border-radius: 5px;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    outline: none;

    /* ${ props => props.mode === "dark" && css`background: #171717;` } */
`

export default SideMenu;